var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$route.query?.id)?_c('tournament-details-page'):_c('tournaments-overview-page')
}
var staticRenderFns = []

export { render, staticRenderFns }